module.exports = __webpack_public_path__ + "12a194359e55450f0b0306fd5cb77389.svg";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/fonts/ArialMT-Bold.svg
// module id = 357
// module chunks = 1